<script lang="ts">
	import { userBalancesEnriched } from '$lib/home/store';
	import { openViewAllTokenModal } from '$lib/home/userInteract/userInteract';
	import Tooltip from '$lib/tooltip/Tooltip.svelte';
	import type { TokenUI } from '$lib/types/tokens';
	import {
		addDollarSign,
		getDecimalOfToken,
		getNumBackInUnits,
		sortInDescendingWithSUSDOnTop
	} from '$lib/util/util';
	import { tokensAllowedForDepositUI } from '../config';
	import { smartContractWalletAddress, tokensInWalletUSD } from '../store';
	import TokenBalanceRow from './TokenBalanceRow.svelte';

	let tokenInDescendingOrder: TokenUI[];
	$: if (
		$userBalancesEnriched &&
		$tokensAllowedForDepositUI &&
		Object.keys($userBalancesEnriched).length !== 0 &&
		$tokensAllowedForDepositUI.reduce((accumulator, token) => {
			return accumulator && $userBalancesEnriched[token.symbol] !== undefined;
		}, true)
	) {
		let tokensAllowedForDepositEnriched: Record<string, TokenUI> = {};

		$tokensAllowedForDepositUI.forEach((token) => {
			tokensAllowedForDepositEnriched[token.symbol] = {
				...$userBalancesEnriched[token.symbol],
				allowed: token.allowed,
				type: token.type
			};
			tokensAllowedForDepositEnriched[token.symbol].allowed = token.allowed;
		});

		tokenInDescendingOrder = sortInDescendingWithSUSDOnTop(
			tokensAllowedForDepositEnriched
		) as TokenUI[];
	}
</script>

<div class="border border-fx-grey-500 w-full rounded-xl squircle-xl h-full p-3">
	<div class="flex flex-col">
		<div class="flex justify-between items-center">
			<Tooltip
				header="Total Balance of Tokens"
				title="Total USD value of tokens in the wallet, tokens that are considered is dependant on auto swap config"
			>
				<p class="text-fx-gradient-5 font-semibold text-lg">
					{#if $tokensInWalletUSD}
						{addDollarSign(getNumBackInUnits($tokensInWalletUSD.toString(), 18, 2))}
					{:else}
						<div>-</div>
					{/if}
				</p>
			</Tooltip>
			<img
				src={'new_sc_wallet/tokens.png'}
				loading="lazy"
				alt="new_sc_wallet/tokens.png"
				class="w-[70px] h-[20px]"
			/>
		</div>

		<div class="flex justify-between items-center">
			<p class="text-sm text-fx-grey-300">Wallet Balance</p>
			<button
				on:click={() => {
					openViewAllTokenModal();
				}}
				on:keydown={() => {
					openViewAllTokenModal();
				}}
			>
				<p class="text-xs text-fx-pink underline underline-offset-2">View All</p>
			</button>
		</div>
	</div>
	<div class="border-t border-t-fx-grey-600 my-2" />
	<div class="flex flex-col gap-2 h-40 overflow-y-auto fx-scrollbar">
		{#if tokenInDescendingOrder && tokenInDescendingOrder.length > 0}
			{#each tokenInDescendingOrder as token}
				<TokenBalanceRow
					{token}
					balance={getNumBackInUnits(token?.balance, getDecimalOfToken(token?.symbol), 2)}
					scwAddress={$smartContractWalletAddress}
					type={token.type}
				/>
			{/each}
		{:else if tokenInDescendingOrder && tokenInDescendingOrder.length === 0}
			<div class="flex flex-col justify-center items-center h-full">
				<img src={'no-trades.webp'} loading="lazy" alt="static/no-trades.webp" class="w-36" />
				<div class="text-fx-grey-300 text-xs">No Balances</div>
			</div>
		{:else}
			<div class="flex flex-col items-center w-full h-full justify-between">
				<div
					class="animate-pulse bg-fx-grey-800 h-12 col-span-2 rounded-lg squircle-lg mx-auto w-full"
				/>
				<div
					class="animate-pulse bg-fx-grey-800 h-12 col-span-2 rounded-lg squircle-lg mx-auto w-full"
				/>
				<div
					class="animate-pulse bg-fx-grey-800 h-12 col-span-2 rounded-lg squircle-lg mx-auto w-full"
				/>
			</div>
		{/if}
	</div>
</div>
